module.exports = __webpack_public_path__ + "assets/img/car02.7292488b.jpg";